import { Logger, LogLevel, RedirectRequest, SilentRequest } from '@azure/msal-browser';
import { REQUEST_SCOPES } from 'common/constants';
import { isIE, isDev } from '../utils/utils';

type MsalConfig = {
    SUPPORT_UI_CLIENT_ID: string;
    TENANT_ID: string;
    SUPPORT_UI_REDIRECT_URL: string;
};

function loggerCallback(
    logLevel: LogLevel,
    message: string,
    containsPii: boolean
) {
    console.log(message);
}

export const msalConfig = (config: MsalConfig) => {
    return {
        auth: {
            clientId: config.SUPPORT_UI_CLIENT_ID,
            authority: `https://login.microsoftonline.com/${config.TENANT_ID}`,
            redirectUri: config.SUPPORT_UI_REDIRECT_URL,
            postLogoutRedirectUri: config.SUPPORT_UI_REDIRECT_URL,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: isIE()
        },
        system: isDev()
        ? {
              navigateFrameWait: 0,
              logger: new Logger({loggerCallback, 
                  logLevel: LogLevel.Verbose,
                  piiLoggingEnabled: true
              })
          }
        : undefined
    }
}

export const redirectRequest: RedirectRequest = {
    scopes: REQUEST_SCOPES.LOGIN.scopes
}

export const silentRequest: SilentRequest = {
    scopes: REQUEST_SCOPES.LOGIN.scopes
}